import NotSupportedScreenSize from 'components/NotSupportedScreenSize';
import { FullScreenLayout } from 'layouts/FullScreenLayout';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SessionDetails from 'scenes/SessionDetails';
import PaymentTerminalBillingDetailsPage from 'scenes/PaymentTerminalBillingDetails';

export const Router: React.FC = () => {
    const billingDetailsElement = (
        <FullScreenLayout>
            <PaymentTerminalBillingDetailsPage />
            <NotSupportedScreenSize />
        </FullScreenLayout>
    );

    return (
        <Routes>
            <Route
                path="/sd/:tenantId/:id"
                element={
                    <FullScreenLayout>
                        <SessionDetails />
                        <NotSupportedScreenSize />
                    </FullScreenLayout>
                }
            />
            <Route
                path="/bd/:tenantId/:token"
                element={billingDetailsElement}
            />
            <Route
                path="/details/:tenantId/:token"
                element={billingDetailsElement}
            />
        </Routes>
    );
};
